import { defineComponent as F, computed as u, inject as I, ref as s, onMounted as O, onUnmounted as q, openBlock as t, createElementBlock as l, normalizeClass as d, normalizeStyle as G, renderSlot as J, createElementVNode as N, toDisplayString as y, createCommentVNode as a, unref as r, createBlock as c, withCtx as K, createVNode as Q } from "vue";
import h from "./novoui-vuejs10.js";
import Y from "./novoui-vuejs24.js";
import { TooltipVariant as S, TooltipPlacement as Z } from "./novoui-vuejs66.js";
import { SortState as m, Variant as g, EHeadCellAlignment as W, getThStyleClasses as x, getThButtonStyleClasses as ee, getThSortStyleClasses as te, TableBodyRowPropsSymbol as ae, getThResizerStyleClasses as oe } from "./novoui-vuejs68.js";
const le = ["data-testid"], se = { key: 0 }, re = {
  key: 0,
  class: "table-head-row-cell-header"
}, ne = {
  key: 1,
  class: "table-head-row-cell-subheader"
}, ie = ["onMouseover"], ue = { key: 4 }, de = {
  key: 0,
  class: "table-head-row-cell-header"
}, ce = {
  key: 1,
  class: "table-head-row-cell-subheader"
}, be = /* @__PURE__ */ F({
  __name: "NTh",
  props: {
    header: { default: void 0 },
    subheader: { default: void 0 },
    sortable: { type: Boolean, default: !1 },
    sortState: { default: m.none },
    tooltipContent: { default: void 0 },
    headVariant: { default: g.light },
    isNotResizable: { type: Boolean, default: !1 },
    alignment: { default: W.left },
    action: { type: Boolean, default: !1 }
  },
  emits: ["click", "column-width"],
  setup($, { emit: D }) {
    const z = D, o = $, L = u(() => x(o)), M = u(() => ee(o)), T = u(() => te(o));
    function P(e) {
      z("click", e);
    }
    const A = I(ae, {
      resizableColumnsRef: !0
    }), H = s(), U = u(() => {
      switch (o.headVariant) {
        case g.dark:
          return S.light;
        case g.light:
          return S.default;
        case g.transparent:
        default:
          return S.default;
      }
    }), v = s();
    O(() => {
      if (o.isNotResizable || v.value.addEventListener("mousedown", _), i.value = k.value.clientWidth, n && n.value) {
        const b = Array.from(n.value.children).reduce(
          (X, j) => X + j.clientWidth,
          0
        ), w = 24 + n.value.children.length * 12;
        f.value = b + w, i.value < f.value && (i.value = f.value);
      }
      z("column-width");
    }), q(() => {
      !o.isNotResizable && v.value && v.value.removeEventListener("mousedown", _);
    });
    const R = s(), k = s(), n = s(), V = s(), i = s(), f = s(), C = s(!1);
    function _(e) {
      R.value = e.clientX, V.value = k.value.clientWidth, C.value = !0, document.addEventListener("mousemove", B), document.addEventListener("mouseup", E);
    }
    function B(e) {
      const b = e.clientX - R.value;
      i.value = V.value + b, z("column-width");
    }
    function E(e) {
      C.value = !1, document.removeEventListener("mousemove", B), document.removeEventListener("mouseup", E);
    }
    const p = u(() => o.alignment === W.right);
    return (e, b) => (t(), l("th", {
      ref_key: "resizableHead",
      ref: k,
      "data-testid": `th-${o.header}`,
      class: d(L.value),
      style: G({ width: `${i.value}px`, minWidth: `${f.value}px` })
    }, [
      J(e.$slots, "default", {}, () => [
        N("button", {
          ref_key: "sortContainer",
          ref: n,
          class: d(M.value),
          onClick: P
        }, [
          (e.header || e.subheader) && !p.value ? (t(), l("span", se, [
            e.header ? (t(), l("p", re, y(e.header), 1)) : a("", !0),
            e.subheader ? (t(), l("p", ne, y(e.subheader), 1)) : a("", !0)
          ])) : a("", !0),
          o.sortable && p.value ? (t(), l("span", {
            key: 1,
            class: d(T.value)
          }, [
            e.sortState === r(m).asc ? (t(), c(h, {
              key: 0,
              icon: "arrowUp",
              size: "small"
            })) : a("", !0),
            e.sortState === r(m).desc ? (t(), c(h, {
              key: 1,
              icon: "arrowDown",
              size: "small"
            })) : a("", !0)
          ], 2)) : a("", !0),
          e.tooltipContent ? (t(), c(Y, {
            key: 2,
            class: "table-head-row-cell-tooltip",
            fixed: !0,
            content: e.tooltipContent,
            variant: U.value,
            placement: r(Z).up,
            "icon-size": 12,
            "aria-label": `table-head-${e.header}-tooltip`
          }, {
            trigger: K((w) => [
              N("div", {
                ref_key: "hoverTrigger",
                ref: H,
                class: "tooltip-hover-trigger",
                onMouseover: () => w.triggerHover(H.value)
              }, [
                Q(h, {
                  size: 12,
                  icon: "information"
                })
              ], 40, ie)
            ]),
            _: 1
          }, 8, ["content", "variant", "placement", "aria-label"])) : a("", !0),
          o.sortable && !p.value ? (t(), l("span", {
            key: 3,
            class: d(T.value)
          }, [
            e.sortState === r(m).asc ? (t(), c(h, {
              key: 0,
              icon: "arrowUp",
              size: "small"
            })) : a("", !0),
            e.sortState === r(m).desc ? (t(), c(h, {
              key: 1,
              icon: "arrowDown",
              size: "small"
            })) : a("", !0)
          ], 2)) : a("", !0),
          (e.header || e.subheader) && p.value ? (t(), l("span", ue, [
            e.header ? (t(), l("p", de, y(e.header), 1)) : a("", !0),
            e.subheader ? (t(), l("p", ce, y(e.subheader), 1)) : a("", !0)
          ])) : a("", !0)
        ], 2)
      ]),
      r(A).resizableColumnsRef && !e.isNotResizable ? (t(), l("div", {
        key: 0,
        ref_key: "resizer",
        ref: v,
        class: d(r(oe)(C.value))
      }, null, 2)) : a("", !0)
    ], 14, le));
  }
});
export {
  be as default
};
